var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-field',{attrs:{"readonly":"","clickable":"","name":"selectPicker","label":_vm.schema.label,"placeholder":_vm.schema.placeholder,"value":_vm.schema.value,"required":_vm.schema.required === true}})
}
var staticRenderFns = []

export { render, staticRenderFns }